export default "__VITE_ASSET__RDyCTq6v__"